import { Marker as MaplibreMarker } from 'react-map-gl/maplibre'
import { Box, Text } from '@machobear/design-system'

import listingIcon from './listing-icon.svg'

type Props = {
  position: [number, number]
  text?: string
}

const Marker = ({ position, text, ...rest }: Props) => {
  return (
    <MaplibreMarker longitude={position[1]} latitude={position[0]} {...rest}>
      <Box
        position="relative"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        cursor="default"
      >
        {text && (
          <Box
            position="absolute"
            padding="small"
            borderRadius="large"
            background="neutral"
            style={{ top: '-72px', width: '260px' }}
          >
            <Text size="small">{text}</Text>
          </Box>
        )}
        <img src={listingIcon} alt="Marker Icon" style={{ width: '92px', height: '92px' }} />
      </Box>
    </MaplibreMarker>
  )
}

export default Marker
